"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#E9E3FD",
  d: "m3 11.99 3.595 2.99 3.596-2.99L6.595 9zm11 0 3.596 2.99 3.595-2.99L17.596 9zm-6-5 3.595 2.99 3.596-2.99L11.595 4zm0 10 3.595 2.99 3.596-2.99L11.595 14z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5B2CE8",
  fillRule: "evenodd",
  d: "M11.552 3.921a.7.7 0 0 1 .896 0l3.487 2.9a.7.7 0 0 1 0 1.077l-3.487 2.9a.7.7 0 0 1-.896 0l-3.487-2.9a.7.7 0 0 1 0-1.077zM9.607 7.36 12 9.35l2.393-1.99L12 5.37zM5.74 8.561a.7.7 0 0 1 .895 0l3.488 2.9a.7.7 0 0 1 0 1.077l-3.488 2.9a.7.7 0 0 1-.895 0l-3.488-2.9a.7.7 0 0 1 0-1.076zm11.625 0a.7.7 0 0 1 .895 0l3.488 2.9a.7.7 0 0 1 0 1.077l-3.488 2.9a.7.7 0 0 1-.895 0l-3.488-2.9a.7.7 0 0 1 0-1.076zM3.795 12l2.393 1.99L8.58 12l-2.392-1.99zm11.625 0 2.393 1.99L20.205 12l-2.392-1.99zm-7.355 4.102 3.487-2.9a.7.7 0 0 1 .896 0l3.487 2.9a.7.7 0 0 1 0 1.076l-3.487 2.9a.7.7 0 0 1-.896 0l-3.487-2.9a.7.7 0 0 1 0-1.076m1.542.538L12 18.63l2.393-1.99L12 14.65z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=WorkAppColorIcon24.js.map